/** Bind a proved cortical text model to the pack's fsaverage5 mapping. */
export async function createCortexTextLayer(viewport,model,{id='mind-text',look}={}) {
  if(model.header.space!=='fsaverage5'||model.header.vertices!==20484)throw new Error('Expected fsaverage5 cortical model');
  const binding=await viewport.send({cmd:'vertexLayer',id,surface:'cortex',space:'fsaverage5',kind:'scalar',
    look:look??{colormap:'coolwarm',range:[-8,8],blend:'mix',albedo:.8,rise:[-1,1]}});
  if(binding?.vertices!==20484){await viewport.send({cmd:'vertexLayer',id,remove:true});throw new Error('Cortex vertex binding mismatch');}
  const empty=new Float32Array(20484).fill(NaN);
  let disposed=false,removal;
  return Object.freeze({id,binding,
    show(text){
      if(disposed)throw new Error('Cortex text layer disposed');
      const result=model.encode(text);
      viewport.setVertexData(id,result.map??empty);
      return result;
    },
    clear(){if(!disposed)viewport.setVertexData(id,empty);},
    dispose(){
      if(!disposed){disposed=true;removal=Promise.resolve().then(()=>viewport.send({cmd:'vertexLayer',id,remove:true}));}
      return removal;
    }
  });
}
